/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkingOverviewRequest } from '../../models/working-overview-request';

export interface ApiV0BinaryHourOverviewContentPost$Json$Params {
      body?: WorkingOverviewRequest
}

export function apiV0BinaryHourOverviewContentPost$Json(http: HttpClient, rootUrl: string, params?: ApiV0BinaryHourOverviewContentPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiV0BinaryHourOverviewContentPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiV0BinaryHourOverviewContentPost$Json.PATH = '/api/v0/binary/hour-overview/content';
